@if (!isMobile) {
    <div class="app-bin-capacity">
      <div class="dflex">
        <label class="container-extra" rtlDiv>
          <img class="transmission-img" src="assets/images/binInfoPage/transmission-black.svg" alt=""/>
          {{ 'LIVE_INFO.TRANSMISSION' | translate }}
          <input id="isTransmission_chc" [(ngModel)]="isTransmission" [checked]="isTransmission" type="checkbox" (change)="transmissionBtn(isTransmission)" rtlDiv>
          <span class="checkmark" rtlDiv></span>
        </label>
      </div>
      <div class="transmission-hover-txt">
        {{ 'LIVE_INFO.TRANSMISSION_TXT' | translate }}
      </div>
      <div class="capacityData-container">
        @if (showDefaultCapacityData()) {
          <div class="default-data">
            <div class="default-img">
              <img src="assets/images/binInfoPage/emptyStateLiveInfo.svg" alt=""/>
            </div>
            <div class="empty-txt">
              {{ 'LIVE_INFO.DEFAULT_TXT_FOR_HOVER' | translate }}
            </div>
          </div>
        }
      </div>
      <div class="capacity-content" id="capacity-container">
        <div style="height: 300px;" id="canvas-frame" [ngClass]="{'hideGraph': !displayChart}">
          <canvas #unfilteredCanvas></canvas>
        </div>
        <div class='chart-btns-wrapper' [ngClass]="{'hideGraph': !displayChart}">
          <div class="chart-btns-container">
            <button class='chart-btn' [ngClass]="{'disabled-btn': isTherePreviousWeek()}" [disabled]="isTherePreviousWeek()" (click)=goToPreviousWeek()>
              <img class='prev-img' src="assets/images/binInfoPage/preview_arrow.svg" alt="" />
              <div class="title">{{ 'LIVE_INFO.PREVIOUS_WEEK' | translate }}</div>
            </button>
            <button class='chart-btn' [ngClass]="{'disabled-btn': isThereNextWeek()}" [disabled]="isThereNextWeek()" (click)=goToNextWeek()>
              <div class="title">{{ 'LIVE_INFO.NEXT_WEEK' | translate }}</div>
              <img class='next-img' src="assets/images/binInfoPage/next_arrow.svg" alt="" />
            </button>
          </div>
        </div>
        <div class="txt-font" [ngClass]="{'hideGraph' : displayChart}">{{ 'LIVE_INFO.NO_CAPACITY' | translate }}</div>
      </div>
    </div>
  }
  
  @if (isMobile) {
      
  }